import { render, staticRenderFns } from "./EvConfigPanel.vue?vue&type=template&id=2cc472f0&scoped=true"
import script from "./EvConfigPanel.vue?vue&type=script&lang=js"
export * from "./EvConfigPanel.vue?vue&type=script&lang=js"
import style0 from "./EvConfigPanel.vue?vue&type=style&index=0&id=2cc472f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc472f0",
  null
  
)

export default component.exports